import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { formatCurrency } from "../../../../../../../utils";
import { SEOPrice } from "../SEOPrice";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
export var PriceSection = function PriceSection(_ref) {
  var title = _ref.title,
    device = _ref.device,
    size = _ref.size,
    isAvailable = _ref.isAvailable;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    price = _useState2[0],
    setPrice = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    oldPrice = _useState4[0],
    setOldPrice = _useState4[1];
  // FOR SSR
  useEffect(function () {
    if (device !== null && device !== void 0 && device.price) {
      setPrice(formatCurrency(device.price));
    }
    if (device !== null && device !== void 0 && device.oldPrice) {
      setOldPrice(formatCurrency(device.oldPrice));
    }
  }, [device]);
  var priceSize = size === 'xl' ? 'size1-b' : 'size2-b';
  var oldPriceSize = size === 'xl' ? 'size4-r' : 'size5-r-s';
  return /*#__PURE__*/React.createElement("div", {
    className: cx('component')
  }, title && /*#__PURE__*/React.createElement(Text, {
    size: "size4-m"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper')
  }, (device === null || device === void 0 ? void 0 : device.price) && /*#__PURE__*/React.createElement(SEOPrice, {
    href: device.absoluteBaseUrl,
    isAvailable: isAvailable,
    price: device.price
  }), price && /*#__PURE__*/React.createElement(Text, {
    size: priceSize,
    tagType: "p"
  }, price), oldPrice && /*#__PURE__*/React.createElement("div", {
    className: cx(size && "old-price--".concat(size))
  }, /*#__PURE__*/React.createElement(Text, {
    color: "grey50",
    crossOutColor: "magenta",
    isCrossedOut: true,
    size: oldPriceSize
  }, oldPrice)), !!(device !== null && device !== void 0 && device.discount) && /*#__PURE__*/React.createElement("div", {
    className: cx('discount', {
      'discount--s': size === 's'
    })
  }, /*#__PURE__*/React.createElement(Text, {
    color: "white",
    size: "size5-m"
  }, "-".concat(device === null || device === void 0 ? void 0 : device.discount, "%")))));
};